export const login = {
  login: 'Zaloguj się',
  email: 'Email',
  password: 'Hasło',
  sendEmail: 'Wyślij email',
  forgotPasswordPara: 'Nie pamiętasz hasła?',
  resetPasswordHeader: 'Zresetuj hasło',
  resetPasswordEmailSent:
    'Email z linkiem do zresetowania hasła został wysłany na Twój adres email.',
  setNewPassword: 'Ustaw nowe hasło',
  newPassword: 'Nowe hasło',
  newPasswordConfirmation: 'Potwierdź nowe hasło',
  passwordChanged: 'Hasło zostało zmienione. Możesz się teraz zalogować.',
  invalidResetLink: 'Nieprawidłowy link do zresetowania hasła',
  passwordMustMatch: 'Hasła muszą się zgadzać',
  profile: 'Profil',
  logout: 'Wyloguj się',
  title: 'Logowanie',
  approved: 'Zatwierdź',
  regenerateChallenge: 'Wygeneruj ponownie kod autentykacyjny',
  sendEmailThrottled: 'Wysłano zbyt wiele próśb. Spróbuj ponownie później.',
}
